import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncAddItem = createAsyncThunk(
  "/fetchAsyncAddItem",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/item/create`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncUpdateItem = createAsyncThunk(
  "/fetchAsyncUpdateItem",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/item/update/${data?.id}`, data?.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetItem = createAsyncThunk(
  "/fetchAsyncGetItem",
  async () => {
    try {
      let url = `${API_URL}/item/get`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncDeleteItem = createAsyncThunk(
  "/fetchAsyncDeleteItem",
  async (id) => {
    try {
      let url = `${API_URL}/item/delete/${id}`;
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncSearchItemsData = createAsyncThunk(
  "/fetchAsyncSearchItemsData",
  async (data) => {
    try {
      let url = `${API_URL}/item/search`;
      if (data.value) {
        url = url + `?search=${data.value}`;
      }
      
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
const AllPurchaseItemSlice = createSlice({
  name: "purchaseItemData",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncGetItem.pending]: (state) => {},
    [fetchAsyncGetItem.fulfilled]: (state, { payload }) => {
      return payload;
    },
    [fetchAsyncSearchItemsData.pending]: (state) => {},
      [fetchAsyncSearchItemsData.fulfilled]: (state, { payload }) => {
        return payload.items;
      },
   
  },
});


export const getAllPurchaseItem = (state) => state.purchaseItemData;

export default AllPurchaseItemSlice.reducer;




